var _circle, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAdd = function SvgAdd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#F0B865"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5952 22.4392C15.4633 22.5712 15.2808 22.6527 15.0798 22.6526C14.6768 22.6527 14.351 22.3269 14.3511 21.9239L14.351 8.07609C14.351 7.67312 14.6768 7.34735 15.0798 7.34735C15.4828 7.34725 15.8086 7.67303 15.8085 8.07609L15.8086 21.9239C15.8085 22.1259 15.7272 22.3073 15.5952 22.4392Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5191 15.5154C22.3871 15.6473 22.2047 15.7288 22.0037 15.7288L8.15592 15.7287C7.75286 15.7288 7.42708 15.403 7.42718 14.9999C7.42718 14.597 7.75286 14.2713 8.15592 14.2712L22.0037 14.2713C22.4068 14.2712 22.7325 14.597 22.7324 15C22.7329 15.2015 22.651 15.3835 22.5191 15.5154Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add.3d44cee2.svg";
export { ForwardRef as ReactComponent };